import React from 'react';

import { DashboardLibraryIntroCard } from '..';
import { SHARED_LIBRARY_INTRO_CARD } from '../../../../../../../shared/constants/workspaceOnboarding';

const SharedLibraryIntroCard = () => {
  return (
    <DashboardLibraryIntroCard
      cardKey={SHARED_LIBRARY_INTRO_CARD}
      heading="Shared Library"
      description="If you invite other Workspace members to edit a video it will show up here."
    />
  );
};

export default SharedLibraryIntroCard;
